import React from 'react';
import { useStore } from '../hooks/useStore';
import { CalendarIcon, ClockIcon, UsersIcon, PhoneIcon, CheckIcon, XIcon } from 'lucide-react';
export function ReservasDashboardPage() {
  const {
    reservations,
    updateReservationStatus
  } = useStore();
  const statusStyle: Record<string, string> = {
    pendiente: 'bg-amber-50 text-amber-700 border-amber-200',
    confirmada: 'bg-emerald-50 text-emerald-700 border-emerald-200',
    cancelada: 'bg-red-50 text-red-700 border-red-200'
  };
  return <div className="min-h-screen bg-stone-50 py-10 px-4" data-id="element-649">
      <div className="max-w-6xl mx-auto" data-id="element-650">
        <div className="flex justify-between items-center mb-8" data-id="element-651">
          <h1 className="font-display text-2xl text-[#1c1917]" data-id="element-652">
            Panel de Reservas
          </h1>
          <span className="text-sm text-stone-500" data-id="element-653">
            Total:{' '}
            <strong className="text-[#1c1917]" data-id="element-654">{reservations.length}</strong>
          </span>
        </div>

        <div className="space-y-4" data-id="element-655">
          {reservations.length === 0 ? <div className="bg-white border border-stone-200 rounded-xl p-12 text-center text-stone-400" data-id="element-656">
              No hay reservas registradas.
            </div> : reservations.map(res => <div key={res.id} className="bg-white border border-stone-200 rounded-xl p-6 flex flex-col md:flex-row justify-between items-start md:items-center gap-5" data-id="element-657">
                <div className="flex-1" data-id="element-658">
                  <div className="flex items-center gap-3 mb-2" data-id="element-659">
                    <h3 className="font-semibold text-lg" data-id="element-660">{res.name}</h3>
                    <span className={`text-[10px] font-bold uppercase px-2.5 py-0.5 rounded-full border ${statusStyle[res.status]}`} data-id="element-661">
                      {res.status}
                    </span>
                  </div>
                  <div className="flex flex-wrap gap-4 text-sm text-stone-500" data-id="element-662">
                    <span className="flex items-center gap-1.5" data-id="element-663">
                      <CalendarIcon className="w-3.5 h-3.5" data-id="element-664" /> {res.date}
                    </span>
                    <span className="flex items-center gap-1.5" data-id="element-665">
                      <ClockIcon className="w-3.5 h-3.5" data-id="element-666" /> {res.time}
                    </span>
                    <span className="flex items-center gap-1.5" data-id="element-667">
                      <UsersIcon className="w-3.5 h-3.5" data-id="element-668" /> {res.guests}
                    </span>
                    <span className="flex items-center gap-1.5" data-id="element-669">
                      <PhoneIcon className="w-3.5 h-3.5" data-id="element-670" /> {res.phone}
                    </span>
                  </div>
                  {res.notes && <p className="mt-3 text-sm bg-amber-50 border border-amber-100 text-amber-800 px-3 py-2 rounded-lg inline-block" data-id="element-671">
                      {res.notes}
                    </p>}
                </div>
                <div className="flex gap-2" data-id="element-672">
                  {res.status === 'pendiente' && <>
                      <button onClick={() => updateReservationStatus(res.id, 'confirmada')} className="px-4 py-2 bg-black text-white text-sm font-semibold rounded-lg hover:bg-[#262626] flex items-center gap-1.5" data-id="element-673">
                        <CheckIcon className="w-4 h-4" data-id="element-674" /> Confirmar
                      </button>
                      <button onClick={() => updateReservationStatus(res.id, 'cancelada')} className="px-4 py-2 border border-stone-200 text-stone-500 text-sm font-semibold rounded-lg hover:bg-red-50 hover:text-red-600 hover:border-red-200 flex items-center gap-1.5" data-id="element-675">
                        <XIcon className="w-4 h-4" data-id="element-676" /> Cancelar
                      </button>
                    </>}
                  {res.status === 'confirmada' && <button onClick={() => updateReservationStatus(res.id, 'cancelada')} className="px-4 py-2 border border-stone-200 text-stone-500 text-sm font-semibold rounded-lg hover:bg-red-50 hover:text-red-600 hover:border-red-200" data-id="element-677">
                      Cancelar
                    </button>}
                </div>
              </div>)}
        </div>
      </div>
    </div>;
}